import React from 'react'
import FooterLogo from '../../Images/TopbarImg/Logo.png'
import '../../css/footer.css'

const Footer = () => {

    const currentDate = new Date().getFullYear()

    return (
        <>
            <div className='footer-links'>
                <div className='footer-logo'>
                    <div className='footer-logo-img'>
                        <img src={FooterLogo} alt='footer-logo' />
                    </div>
                </div>
                <div className='footer-links-contact'>
                    <div className='links-contact-header'>
                        <h3>Contact Us</h3>
                    </div>
                    <div className='links-contact-body'>
                        <div className='contact-body-detail'>
                            <ul>
                                <li><i className='bi bi-geo-alt-fill' /><p>सुन्दरहरैचा – ७, मोरङ, नेपाल</p></li>
                                <li><i className='bi bi-telephone-fill' /><p className='phone'>०२१-४३००६६</p></li>
                                <li><i className='bi bi-envelope-fill envelopicon' /><p><a href='mailto:kanaklaxmisaccos2077@gmail.com'>kanaklaxmisaccos2077@gmail.com</a></p></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='footer-links-section'>
                    <div className='quick-links-header'>
                        <h3>Quick Links</h3>
                    </div>
                    <div className='quick-links-list'>
                        <ul>
                            <li><a href='/hr/bod-members'>संचालक समिति</a></li>
                            <li><a href='/hr/FBODS'>पुर्व संचालक समिति</a></li>
                            <li><a href='/service/other-member-sevice'>अन्य सदस्य सेवा</a></li>
                            <li><a href='/branches/all'>सेवाकेन्द्रहरु</a></li>
                            <li><a href='/service/mobile-banking-service'>मोबाइल बैङकिङ सेवा</a></li>
                            <li><a href='/report/PEARLS'>पर्ल्स प्रतिवेदन</a></li>
                        </ul>
                    </div>
                </div>
                <div className='footer-social'>
                    <div className='social-header'>
                        <h3>Social Media</h3>
                    </div>
                    <div className='social-body'>
                        <div className='social-body-bg'>
                            <a href='https://www.facebook.com/kanaklaxmi.saccos' target='_blank' rel='noreferrer' title='facebook'><i className='bi bi-facebook facebook' /></a>
                        </div>
                        <div className='social-body-bg'><a href='https://www.facebook.com/kanaklaxmi.saccos' target='_blank' rel='noreferrer' title='youtube'><i className='bi bi-youtube youtube' /></a></div>
                        <div className='social-body-bg'><a href='https://www.facebook.com/kanaklaxmi.saccos' target='_blank' rel='noreferrer' title='thread'><i className='bi bi-threads twitter' /></a></div>
                        <div className='social-body-bg'><a href='https://www.facebook.com/kanaklaxmi.saccos' target='_blank' rel='noreferrer' title='pinterest'><i className='bi bi-pinterest pinterest' /></a></div>
                    </div>
                </div>
            </div>
            <div className='footer-section'>
                <div className="text-center">
                    <h6 className="text-center mt-2">&copy; {currentDate} DESIGNED BY : BIGUTAR IT SOLUTION</h6>
                </div>
            </div>
        </>
    )
}

export default Footer